import Vue from 'vue'
import store from './../store/index'

const container = {
  get: function () {
    return require('./../locales/languages-list/' + store.state.lang + '.json')
  }
}

const plugin = function (Vue, options) {
  Vue.prototype.$languagesList = container
  Vue.$languagesList = container
}

Vue.use(plugin)
